import React, { useEffect, useState } from "react";
import { searchUsers } from "../utilities/genesysCloudUtils";
import "../App.css";
import { DataTable, AlertBlock } from "genesys-react-components";
import { Loading } from "./Loading";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Users({
  // checkedDivisions,
  setPageCount,
  pageNumber,
  setPageNumber,
  setOpts,
  setTabName,
  filters,
  setIsVisible,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setOpts({
      state: {
        format: "dropdown",
        state: "active",
        items: [
          {
            label: "active",
            value: "active",
          },
          {
            label: "inactive",
            value: "inactive",
          },
          {
            label: "deleted",
            value: "deleted",
          },
          {
            label: "any",
            value: "any",
          },
        ],
      },
      name: "",
    });
    setPageNumber(1);
    setTabName("users-tab");
    setIsVisible({ divisions: true, object: true, applyButton: true })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   setPageNumber(1);
  //   console.log(filters.checkedDivisions);
  // }, [filters.checkedDivisions]);

  useEffect(() => {
    console.log("Filters in Users component:", filters);
    generateUsers(true); // true indicates filter change, reset to page 1
  }, [filters.state, filters.name, filters.checkedDivisions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    generateUsers(false); // false indicates page change only
  }, [pageNumber]); // eslint-disable-line react-hooks/exhaustive-deps

  const generateUsers = (resetPage = false) => {
    setLoading(true);
    setError(null);

    const currentPage = resetPage ? 1 : pageNumber;

    if (resetPage && pageNumber !== 1) {
      setPageNumber(1);
    }

    let divisionFilters = {
      operator: "AND",
      type: "EXACT",
      fields: ["divisionId"],
      values: filters.checkedDivisions,
    };

    let stateFilter = {};

    if (filters.state && filters.state.state === "any") {
      stateFilter = {
        operator: "AND",
        type: "EXACT",
        fields: ["state"],
        values: ["active", "inactive", "deleted"],
      };
    } else {
      stateFilter = {
        operator: "AND",
        type: "EXACT",
        fields: ["state"],
        value:
          filters.state && filters.state.state ? filters.state.state : "active",
      };
    }

    let nameFilter = {
      operator: "AND",
      type: "CONTAINS",
      fields: ["name", "email"],
      value: filters.name || "",
    };

    let body = {
      query: [stateFilter],
      sortOrder: "ASC",
      sortBy: "name",
      pageSize: 100,
      pageNumber: currentPage,
      expand: ["authorization", "station", "dateLastLogin", "team"],
    };
    if (filters.name && filters.name.length > 0) {
      body.query = [...body.query, nameFilter];
    }
    if (filters.checkedDivisions && filters.checkedDivisions.length !== 0) {
      body.query = [...body.query, divisionFilters];
    }

    console.log("Request Body for searchUsers:", body);
    searchUsers(body)
      .then((data) => {
        if (!data || !data.results || data.results.length === 0) {
          setUsers([]);
          setLoading(false);
          setError("No users found matching the criteria.");
          return;
        }
        setUsers(data.results);
        setPageCount(data.pageCount);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        setError("Error fetching users: " + error);
        setLoading(false);
      });

    // getUsers(
    //   // 1000, pageNumber, [], "ASC", ["authorization", "station", "dateLastLogin", "team"], "active"
    //   {
    //     pageSize: 100, // Number | Page size
    //     pageNumber: currentPage, // Number | Page number
    //     sortOrder: "ascending", // String | Ascending or descending sort order
    //     expand: ["authorization", "station", "dateLastLogin", "team"], // [String] | Which fields, if any, to expand. Note, expand parameters are resolved with a best effort approach and not guaranteed to be returned. If requested expand information is absolutely required, it's recommended to use specific API requests instead.
    //     state: filters.state && filters.state.state ? filters.state.state : "active", // String | Filters users by their state. If not specified, only active users will be returned.
    //   }
    // ).then(({ opts, usersData }) => {
    //   if (filters.checkedDivisions.length > 0) {
    //     usersData.entities = usersData.entities.filter((user) => {
    //       return filters.checkedDivisions.includes(user.division.id);
    //     });
    //   }
    //   setUsers(usersData.entities);
    //   setPageCount(usersData.pageCount);
    //   setLoading(false);
    // });
  };

  const tableProps = {
    className: "table",
    headerRow: {
      cells: [
        {
          content: "",
          align: "center",
          className: "select-column",
        },
        {
          content: "User",
          align: "center",
        },
        {
          content: "Email",
          align: "center",
        },
        {
          content: "Division",
          align: "center",
        },
        {
          content: "Role",
          align: "center",
        },
        {
          content: "Last Login",
          align: "center",
        },
        {
          content: "Station",
          align: "center",
        },
        {
          content: "Auto Answer?",
          align: "center",
        },
        {
          content: "Team",
          align: "center",
        },
        {
          content: "Phone Number",
          align: "center",
        },
        {
          content: "User ID",
          align: "center",
        },
      ],
    },
    indentation: 0,
    rows: users.map((user) => {
      return {
        cells: [
          {
            renderedContent: (
              <input
                aria-label={`Select ${user.name} for export`}
                checked={Boolean(selectedExportRows[user.id])}
                onChange={(event) => onToggleExportRow(user, event.target.checked)}
                type="checkbox"
              />
            ),
            content: selectedExportRows[user.id] ? "selected" : "",
            align: "center",
            className: "select-column",
          },
          {
            content: user.name,
            align: "left",
          },
          {
            content: user.email,
            align: "left",
          },
          {
            content: user.division.name,
            align: "left",
          },
          {
            content: !user.authorization ? 0 : user.authorization.roles.length,
            align: "center",
          },
          {
            content: !user.dateLastLogin
              ? "-"
              : new Date(user.dateLastLogin).toLocaleString(),
            align: "left",
          },
          {
            renderedContent: <>{user.station ? "✔" : "-"}</>,
            content: user.station ? "true" : "false",
            align: "center",
          },
          {
            renderedContent: <>{user.acdAutoAnswer ? "ON" : "-"}</>,
            content: user.acdAutoAnswer ? "on" : "off",
            align: "center",
          },
          {
            content: !user.team ? "-" : user.team.name,
            align: "left",
          },
          {
            content: user.primaryContactInfo?.find(c => c.mediaType === "PHONE")?.display,
            align: "left",
          },
          {
            renderedContent: <kbd className="kbd">{user.id}</kbd>,
            content: user.id,
            align: "left",
          },
        ],
      };
    }),
  };
  const allVisibleSelected = users.length > 0 && users.every((user) => selectedExportRows[user.id]);

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      filteredExportAvailable={true}
      loading={loading}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: users })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(users, checked)}
      rowCount={users.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Users"
    >
      {loading && <Loading text="Loading Users..." />}
      {error && (
        <AlertBlock
          title={error}
          alertType="critical"
          className="clazzy-alertblock error-search"
        />
      )}
      {!loading && !error && users && (
        <DataTable
          sortable={true}
          // filterable={true}
          headerRow={tableProps.headerRow}
          rows={tableProps.rows}
          className="table-pin-rows users-table"
        />
      )}
    </CatalogTableSurface>
  );
}

// {
//   "query": [
//     {
//       "operator": "AND",
//       "type": "CONTAINS",
//       "value": "dian",
//       "fields": [
//         "name"
//       ]
//     }
//   ],
//   "sortOrder": "ASC",
//   "sortBy": "name"
// }
